var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1316CF",
    fillRule: "evenodd",
    d: "M0 6.009C0 2.849 2.526 0 6.012 0 9.42 0 12 2.794 12 5.991 12 9.699 8.976 12 6 12c-.984 0-2.076-.264-2.952-.781-.306-.186-.564-.325-.894-.216l-1.212.36c-.306.096-.582-.144-.492-.469l.402-1.346a.63.63 0 0 0-.042-.54C.294 8.058 0 7.018 0 6.009m3.221.775a.774.774 0 0 1-.768-.769c0-.426.342-.769.768-.769s.768.343.768.77c0 .42-.342.762-.768.768m4.765-.769c0 .42.342.77.768.77a.77.77 0 0 0 0-1.539.766.766 0 0 0-.768.77zM5.221 6.01c0 .427.342.77.768.775a.77.77 0 0 0 0-1.538.765.765 0 0 0-.768.763",
    clipRule: "evenodd"
  })));
};
export default SvgChat;